<template>
  <div class="video-wraper">
    <div class="video-title">{{ title }}</div>
    <div class="video-container">
      <iframe
          class="video"
          :src="src"
          :title="title"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoSupportCard',
  props: {
    src: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.video-title {
  max-width: 500px;
  height: 20px; /* set a fixed height */
  overflow: hidden;
  font-size: 15px;
  padding-bottom: 10px;
  white-space: nowrap; /* prevent text from wrapping to the next line */
  text-overflow: ellipsis; /* add ellipsis when the text overflows */
  margin-bottom: 5px; /* add bottom margin */
}
.video-wraper{
  width: 100%;
}
.video-container {
  width: 558px;
  height: 311px;
  max-width: 100%;
  overflow: hidden;
  border: 1px solid #ccc;
  border-radius: 5px;
  position: relative;
}
.video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Newsletter/Tabs/VideoSupportCard.vue